import { render, staticRenderFns } from "./CallParkingItem.vue?vue&type=template&id=889e5160&scoped=true&"
import script from "./CallParkingItem.vue?vue&type=script&lang=js&"
export * from "./CallParkingItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889e5160",
  null
  
)

export default component.exports